import { App } from './models'

export interface Package {
  name?: string
  packages?: Package[]
  apps?: App[]
}
